import { useEffect, useContext } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import useCustomHook from '@/hooks/useCustomHook';

export default function useSortImagesButtons({ activity }) {
  const context = useContext(GlobalContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      selectedAction: null,
      canLaunch: false,
    },
    actions: {
      setSelectedAction: (selectedAction) => {
        actions.setState({ selectedAction });
      },
      onActionClose: () => {
        actions.setState({ selectedAction: null });
      },
    },
  });

  useEffect(() => {
    if (activity?.data && context.state.loaded) {
      actions.setState({
        canLaunch:
          context.state.user?.teacher && context.state.isSubscriptionActive,
      });
    }
  }, [activity, context.state]);

  return { state, actions };
}
